/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateReplyCommandResult } from '../../models/update-reply-command-result';

export interface ApiKpiReportsUpdateReplyPost$Params {
      body?: {
'Id'?: string;
'NoteId'?: string;
'ParentId'?: string;
'Notes'?: string;
'Lat'?: number;
'Lng'?: number;
'IsDuplicated'?: boolean;
'ImageRate'?: number;
'Attachments'?: Array<Blob>;
}
}

export function apiKpiReportsUpdateReplyPost(http: HttpClient, rootUrl: string, params?: ApiKpiReportsUpdateReplyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateReplyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpiReportsUpdateReplyPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateReplyCommandResult>;
    })
  );
}

apiKpiReportsUpdateReplyPost.PATH = '/api/KPIReports/UpdateReply';
